import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { eq } from 'ember-truth-helpers';
import ExceptionIndicator from 'lumen/components/hotel/pricing-assistant/exception-indicator';
import OverrideIndicator from 'lumen/components/hotel/pricing-assistant/override-indicator';

import styles from './td-own-rate-dynamic-rate-pricing-cell-value.module.css';

interface HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricingCellValueSignature {
  Args: {
    isPast: boolean;
    priceChangeDirection: 'up' | 'down' | null;
    showException: boolean;
    showOverride: boolean;
  };
}

const HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricingCellValue: TOC<HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricingCellValueSignature> =
  <template>
    <div class="{{styles.cell-icon-block}} flex items-center">
      {{#if @showException}}
        <ExceptionIndicator />
      {{else if @showOverride}}
        <OverrideIndicator @isDisabled={{@isPast}} />
      {{else if @priceChangeDirection}}
        <PrismIcon
          @color={{if
            (eq @priceChangeDirection "up")
            "on-success"
            "on-critical"
          }}
          @name={{if (eq @priceChangeDirection "up") "arrow-up" "arrow-down"}}
          @size="small"
          data-arrow-direction={{@priceChangeDirection}}
          data-test-id="price-change-direction-arrow"
        />
      {{/if}}
    </div>
  </template>;

export default HotelPricingAssistantTableCellsTdOwnRateDynamicRatePricingCellValue;
